import React from 'react'
import { useNavigate } from 'react-router'
import { Box, Grid, IconButton, Typography } from '@mui/material'

import { ArrowBack } from '@mui/icons-material'

type Props = {
  title: string
  breadcrumbs?: React.ReactNode
  arrowBack?: boolean
}

const PageTitle = ({ title, breadcrumbs, arrowBack }: Props) => {
  const navigate = useNavigate()

  return (
    <>
      <Grid container>
        {arrowBack && (
          <IconButton
            onClick={() => {
              navigate(-1)
            }}
          >
            <ArrowBack />
          </IconButton>
        )}
        <Grid item xs={12}>
          <Typography variant="h1">{title}</Typography>
        </Grid>
        {breadcrumbs && (
          <Box
            sx={{
              marginTop: '10px',
            }}
          >
            {breadcrumbs}
          </Box>
        )}
      </Grid>
    </>
  )
}

export default PageTitle
